import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    QStype:"",
    userInfo:{
      name:"",
      id:"",
    },
    enrollFormId:"",
    idcard:""
  },
  mutations: {
  },
  actions: {
  },
  modules: {
  }
})
